import { _drag } from './_drag';
import { _next } from './_next';
import { _prev } from './_prev';
import { _point } from './_point';
import { _navigator } from './_navigator';
import { _autoplay } from './_autoplay';
import { _fade } from './_fade';

/*
 * Add navigation-functionality to every
 * slider using the data-attribute: slider ([data-slider]).
 */
export const _navigation = () => {
	const sliders = document.querySelectorAll( '[data-slider]' );

	sliders.forEach( ( slider ) => {
		const sliderId = slider.getAttribute( 'data-slider' ) ? slider.getAttribute( 'data-slider' ) : null;
		const list = slider.querySelector( '[data-slider-list]' );
		const prev = slider.querySelector( '[data-slider-prev]' );
		const next = slider.querySelector( '[data-slider-next]' );
		const isDraggable = slider.getAttribute( 'data-slider-draggable' ) !== null;
		const autoplay = slider.getAttribute( 'data-slider-autoplay' ) !== null;
		const navigator = sliderId ? document.querySelector( `[data-navigator="${ sliderId }"]` ) : null;
		let interval = null;

		if ( navigator ) {
			_navigator( navigator, () => {
				clearInterval( interval );

				interval = setInterval( () => {
					_autoplay( slider );
				}, 6 * 1000 );
			} );
		}

		if ( isDraggable ) {
			_drag( slider );
		}

		if ( autoplay ) {
			_fade( slider, 0 );

			interval = setInterval( () => {
				_autoplay( slider );
			}, 6 * 1000 );
		}

		if ( prev && next ) {
			prev.addEventListener( 'click', _prev );
			next.addEventListener( 'click', _next );
		}

		list.addEventListener( 'scroll', () => {
			const current = _point( list ).id;
			slider.setAttribute( 'data-slider-current', current );
		} );
	} );
};

